var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Hey")]),_c('button',{on:{"click":_vm.test}},[_vm._v("Click")]),_c('button',{on:{"click":_vm.firebasee}},[_vm._v("Click Fiah")])])}
var staticRenderFns = []

export { render, staticRenderFns }